// extracted by mini-css-extract-plugin
export default {"headerIcon":"Organization_headerIcon__vXayA","tableHeader":"Organization_tableHeader__e697P","tableBody":"Organization_tableBody__Ba0D7"};